import $ from 'jQuery';


let form;
const recipient = 'contact@copade.immo';
const project = 'Les Hauts du Port';
const source = 'website';
const projectSlug = 'hauts-du-port';
const apiUrl = 'https://piaf.drawbotics.com/api/v1/messages';


function init() {
  form = $('.js-form-submit');
  // contact = $('.Contact');
  // message = $('.Contact__messageSent');
  // button = contact.find('.Contact__button');

  if (form[0]) {
    _attachEvents();
  }
}


function _attachEvents() {
  form.on('submit', _handleSubmitForm);
}


function _handleSubmitForm() {
  const name = form[0]['name'].value;
  const surname = form[0]['surname'].value;
  const email = form[0]['email'].value;
  const phone = form[0]['phone'].value;
  const message = form[0]['message'].value;

  const data = {
    message: {
      recipient: recipient,
      project: project,
      content: message,
      name: `${name} ${surname}`,
      phone: phone,
      sender: email,
      source: source,
      project_slug: projectSlug,
    },
  };

  $.ajax({
    url: apiUrl,
    data: data,
    type: 'POST',
    crossDomain: true,
    crossOrigin: true,
    dataType: 'json',
  }).done(_requestSuccess);
}


function _requestSuccess() {
  form[0].reset();
}


export default {
  init,
};


// WEBPACK FOOTER //
// ./src/static/js/modules/submit-form.js